import React, { useState } from 'react';
import useScrollLock from '../utils/useScrollLock';

const FEEDBACK_KEYS = [
  'polite',
  'clean',
  'onTime',
  'safeDriving',
  'goodRoute',
];

export default function RatingSheet({ t, fare, onSubmit, onSkip, busy }) {
  const [rating, setRating] = useState(5);
  const [comment, setComment] = useState('');
  const [tags, setTags] = useState([]);
  useScrollLock();

  const toggleTag = (key) => {
    setTags((prev) => (
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
    ));
  };

  const dismiss = onSkip || (() => {});

  return (
    <div
      className="modal-backdrop"
      role="presentation"
      onClick={() => { if (!busy) dismiss(); }}
    >
      <div
        className="modal-sheet"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <h3>{t('rating.title')}</h3>
        <p className="text-muted">{t('rating.subtitle')}</p>
        <div className="rating-stars">
          {[1, 2, 3, 4, 5].map((n) => (
            <button
              key={n}
              type="button"
              className={`rating-star${n <= rating ? ' on' : ''}`}
              onClick={() => setRating(n)}
              aria-label={`${n}`}
            >
              ★
            </button>
          ))}
        </div>

        <p className="rating-chips-label">{t('rating.quickFeedback')}</p>
        <div className="rating-chips">
          {FEEDBACK_KEYS.map((key) => (
            <button
              key={key}
              type="button"
              className={`rating-chip${tags.includes(key) ? ' on' : ''}`}
              onClick={() => toggleTag(key)}
            >
              {t(`rating.tags.${key}`)}
            </button>
          ))}
        </div>

        <input
          type="text"
          placeholder={t('rating.commentPlaceholder')}
          value={comment}
          onChange={(e) => setComment(e.target.value.slice(0, 200))}
        />
        <p className="rating-total text-muted">
          {t('rating.fareWas', { fare })}
        </p>
        <button
          type="button"
          className="btn btn-primary"
          disabled={busy}
          onClick={() => onSubmit({ rating, tip: 0, comment, tags })}
        >
          {t('rating.submit')}
        </button>
        {onSkip && (
          <button type="button" className="btn btn-ghost" disabled={busy} onClick={onSkip}>
            {t('rating.skip')}
          </button>
        )}
      </div>
    </div>
  );
}
